import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import InsideShop from './views/InsideShop.vue'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/inside-partners',
      name: 'inside-partners',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "inside-partners" */ './views/InsidePartners.vue')
    },
    {
      path: '/inside-team',
      name: 'inside-team',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "inside-team" */ './views/InsideTeam.vue')
    },
    {
      path: '/inside-shop',
      name: 'inside-shop',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "inside-shop" */ './views/InsideShop.vue')
      component: InsideShop
    },
    {
      path: '/docs/:lang/:name',
      name: 'docs',
      component: () => import('./views/docs/PdfDocument')
    },
    {
      path: '/:lang/:loginName/:us',
      name: 'url',
      props: true,
      component: () => import('./layouts/parts/AuthBlock')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
export default router
